import { render, staticRenderFns } from "./_2.vue?vue&type=template&id=a324a2d6&scoped=true&"
import script from "./_2.vue?vue&type=script&lang=js&"
export * from "./_2.vue?vue&type=script&lang=js&"
import style0 from "./_2.vue?vue&type=style&index=0&id=a324a2d6&prod&scoped=true&lang=css&"
import style1 from "./_2.vue?vue&type=style&index=1&id=a324a2d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324a2d6",
  null
  
)

export default component.exports